import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SEO_DATA = {

  '/': {
    title: 'Centro di Riabilitazione e Performance a Verona | MCARE',
    description:
      'MCARE è un centro di riabilitazione situato alle porte di Verona. Offriamo trattamenti personalizzati per recupero post-infortunio, post-chirurgico, e gestione del dolore cronico. Prenota una visita oggi stesso!',
    // image: 'https://mcarefisio.it/static/media/logo2.47585272f37641121cdd.png',
    image: "https://mcarefisio.it/assets/logo/ogMCare-2.png"
  },
  '/staff/': {
    title: 'Chi siamo | MCARE',
    description:
      'Conosci il nostro team di professioni di MCare, al tuo fianco per raggiungere i tuoi obiettivi di performance.',
    // image: 'https://mcarefisio.it/static/media/spalla.95fc5bd3aeb3e81ca422.jpg',
    image: "https://mcarefisio.it/assets/logo/spalla.jpg"
  },

  '/fisioterapia/': {
    title: 'Fisioterapia | MCARE',
    description:
      'Scopri le nostre aree di intervento per rimetterti in gioco e tornare finalmente al tuo livello di performance desiderato!',
    // image: 'https://mcarefisio.it/static/media/fisioterapia.5a8a8cee187702bae6bb.jpg',
    image: "https://mcarefisio.it/assets/logo/fisioterapia.jpg"
  },

  '/formazione/': {
    title: 'Formazione | MCARE',
    description:
      "In MCare la formazione è essenziale, perché vogliamo offrirti le cure migliori e all'avanguardia. Scopri di più!",
    //image: 'https://mcarefisio.it/static/media/formazione.4139192d7b939c3d5d8e.jpg',
    image: "https://mcarefisio.it/assets/logo/formazione.jpg"
  },

  '/tecnologie/': {
    title: 'Tecnologia | MCARE',
    description:
      'Sfruttiamo le tecnologie più avanzate per aiutarti nel percorso di rimessa in campo. Scoprile ora!',
    // image: 'https://mcarefisio.it/static/media/the-procedure-of-myo.6a79a18451da325d620b.jpg',
    image: "https://mcarefisio.it/assets/logo/the-procedure-of-myo.jpg"
  },

  '/servizi/': {
    title: 'Servizi | MCARE',
    description:
      'Una sfida non solo fisica, ma anche mentale: con MCare ti diamo il supporto psicologico di cui hai bisogno. Scopri come!',
    // image: 'https://mcarefisio.it/static/media/player.ac5171e753bd63e2ffa2.jpg',
    image: "https://mcarefisio.it/assets/logo/player.jpg"
  },
  '/privacypolicy/': {
    title: 'Privacy Policy | MCARE',
    description:
      'Leggi la privacy policy di MCare.',
    //image: 'https://mcarefisio.it/static/media/logo2.47585272f37641121cdd.png',
    image: "https://mcarefisio.it/assets/logo/ogMCare-2.jpg"
  },
};

function Seo() {
  const location = useLocation();

  const pathname = location.pathname.endsWith('/')
    ? location.pathname
    : `${location.pathname}/`;

  const currentSeo = SEO_DATA[pathname] || SEO_DATA['/'];

  const canonicalUrl = `https://mcarefisio.it${pathname}`;

  return (
    <Helmet>
      <title>{currentSeo.title}</title>

      <meta
        name="description"
        content={currentSeo.description}
      />
      <meta property="og:title" content={currentSeo.title} />
      <meta property="og:description" content={currentSeo.description} />
      <meta property="og:image" content={currentSeo.image} />

      <link
        rel="canonical"
        href={canonicalUrl}
      />
    </Helmet>
  );
}

export default Seo;